<template>
  <div class="anchor_set">
    <el-dialog
      :title="word"
      :visible="true"
      width="505px"
      @close="close_dialog"
      :close-on-click-modal="false"
      v-dialogDrag
      class="anchor_pop"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        :label-width="$store.state.app.web_language_wm == 'en' ? '' : 95"
        class="ruleFormStyle"
        label-position="left"
      >
        <el-form-item :label="$t('components_my_anchor_set_index_2227')" prop="anchorName" class="anchorName">
          <el-input
            :placeholder="$t('components_my_anchor_set_index_2228')"
            v-model="ruleForm.anchorName"
            class="nameInput"
            :maxlength="50"
            :minlength="2"
          ></el-input>
          <span
            v-if="$store.state.anchor.selectedData.data.anchor_id"
            class="removeAnchor"
            @click="clearAnchor"
          >
            <i class="el-icon-delete"></i>{{$t('base_kindeditor_all_1551')}}</span>
        </el-form-item>
        <div class="checkLine">
          <el-checkbox v-model="createNav" :title="$t('components_my_anchor_set_index_2229')" >{{$t('components_my_anchor_set_index_2229')}}
            <!-- <el-tooltip placement="right" effect="light">
            <div slot="content">新增导航项点击直接跳转到锚点位置</div>
            <i></i>
            </el-tooltip>--></el-checkbox>
          <el-popover
            placement="right"
            trigger="hover"
            :visible-arrow="false"
            popper-class="anchor_popover"
          >
            <div class="jz_tooltip_img">
              <div class="jz_tooltip_img_title">{{$t('components_my_anchor_set_index_2230')}}</div>
              <img class="jz_tooltip_img_img" src="@/assets/image/anchor_tip.gif" />
            </div>
            <i slot="reference" class="iconfont icon-wenhao" style="cursor: pointer;"></i>
          </el-popover>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <!-- <el-button type="primary" :disabled='!ruleForm.anchorName' @click="submitForm('ruleForm')">确 定</el-button> -->
        <el-button type="primary" @click="submitForm('ruleForm')">{{$t('view_public_topbar_15')}}</el-button>
        <el-button @click="close_dialog">{{$t('view_public_topbar_14')}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import i18n from '../../language/index'

import { save_anchor, get_anchor, addNav, deleteNav } from '@/api/app';
export default {
  name: 'anchor_set',
  data () {
    return {
      dialogVisible: false,
      word: this.$store.state.anchor.popWord,
      baseAnchorName: '',
      createNav: false,
      baseList: [],
      baseAllList: [],
      navID: '',
      rules: {
        anchorName: [
          {
            required: true,
            message: i18n.t('components_my_anchor_set_index_2228'),
            trigger: 'blur'
          },
          {
            min: 2,
            max: 50,
            // pattern: /^[\u4e00-\u9fa5]{0,6}$/,
            message: i18n.t('components_my_anchor_set_index_2231'),
            trigger: 'blur'
          }
        ]      },
      ruleForm: {
        anchorName: '',
      },
      submitDisabled: this.$store.state.anchor.selectedData.data.anchor_id ? true : false,
      confirmDisabled: true,
      isResetForm: true,
    };
  },
  watch: {
    createNav () {
      this.submitDisabled = false
      this.confirmDisabled = false
    },
    'ruleForm.anchorName' () {
      if (!this.isResetForm) {
        this.confirmDisabled = false
      } else {
        this.confirmDisabled = true
        this.isResetForm = false
      }
    }
  },
  methods: {
    clearAnchor () {
      this.$confirm(i18n.t('components_my_anchor_set_index_2232'), '', {
        confirmButtonText: i18n.t('view_public_topbar_24'),
        cancelButtonText: i18n.t('view_public_topbar_11'),
        type: 'warning'
      })
        .then(() => {
          this.ruleForm.anchorName = ''
          let deleteID = this.$store.state.anchor.selectedData.data.anchor_id;
          let anchorNewList = this.baseList.filter(e => {
            return e.id !== deleteID;
          });
          delete this.$store.state.anchor.selectedData.data.anchor_id;
          if (this.navID) {
            this.deleteNav(this.navID, this.templet.p_save(this.save_anchor(anchorNewList, 'delete')))
          } else {
            this.templet.p_save(this.save_anchor(anchorNewList, 'delete'))
          }

        })
        .catch(() => { });

    },
    closePop () {
      this.$store.commit('anchor/SET_popShow', false);
    },
    get_anchor () {
      let data = {
        page: this.$store.state.app.now_page
      };
      let that = this
      get_anchor(data)
        .then(res => {
          if (res.code === 200) {
            let editData = that.$store.state.anchor.selectedData;
            that.baseAllList = res.data;
            if (editData.rowType === 'footer') {
              that.baseList = res.data.common;
            } else {
              that.baseList = res.data.thisPage;
            }
            if (editData.data.anchor_id) {
              that.baseList.map(e => {
                if (e.id === editData.data.anchor_id) {
                  that.ruleForm.anchorName = e.anchorName;
                  this.baseAnchorName = e.anchorName;
                  that.createNav = e.createNav;
                  that.navID = e.navID
                }
              });
            }
          } else {
            that.$message.error(res.message);
          }
        })
        .catch(error => { })
        .finally(() => {
          if (!that.ruleForm.anchorName) {
            let editData = that.$store.state.anchor.selectedData;
            that.ruleForm.anchorName = that.$store.state.left_sidebar.PendantObj[editData.name] ? this.$store.state.left_sidebar.PendantObj[editData.name].title : i18n.t('components_my_anchor_set_index_2233')
          }        });
    },
    deleteNav (navID, fn) {
      deleteNav({ id: navID })
        .then(res => {
          if (res.code === 200) {
            this.$message.success(i18n.t('components_my_anchor_set_index_2234'));
            if (typeof fn === 'function') {
              fn();
            }
          } else {
            this.$message.error(res.message);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    submitForm (formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let editData = this.$store.state.anchor.selectedData;
          let tag = false;
          if (editData.widgets_id > 999999) {
            tag = true;
          }
          if (!editData.data.anchor_id) {
            // editData.data.anchor_id = this.uuid();
            this.$set(editData.data, 'anchor_id', this.uuid());

          }
          if (tag || this.$store.state.app.is_change) {
            this.$confirm(i18n.t('components_my_anchor_set_index_2235'), '', {
              confirmButtonText: i18n.t('components_my_anchor_set_index_2236'),
              cancelButtonText: i18n.t('view_public_topbar_11'),
              type: 'warning'
            })
              .then(() => {
                this.templet.p_save(this.sendAnchor(editData.data.anchor_id));
              })
              .catch(() => { });
          } else {
            this.templet.p_save(this.sendAnchor(editData.data.anchor_id));
          }
        }
      })
    },
    sendAnchor (id) {
      let anchor = {
        id: id,
        anchorName: this.ruleForm.anchorName,
        createNav: this.createNav,
        navID: this.navID
      };
      let word = this.ruleForm.anchorName;
      if (this.createNav === true && !this.navID) {
        let now_page = this.$store.state.app.now_page
        let pageListData = this.$store.state.app.websiteSection
        let link = ''
        // debugger
        // pageListData.map(e => {
        //   if (e.routerPath === now_page) {
        //     link = e.module
        //   }
        // })
        for (let i = 0; i < pageListData.length; i++) {
          if (pageListData[i].routerPath === now_page) {
            link = pageListData[i].module
            break
          }
        }
        let createNavData = {
          pageType: 'anchor',
          title: this.ruleForm.anchorName,

          pid: 0,
          link: link + '#' + id
        }
        addNav(createNavData).then(res => {
          if (res.code === 200) {
            this.$message.success({
              showClose: true,
              message: i18n.t('components_my_anchor_set_index_2237')
            });
            anchor.navID = res.data
            let tag = true;
            this.baseList.map(e => {
              if (e.id === anchor.id) {
                e.anchorName = anchor.anchorName;
                e.createNav = anchor.createNav;
                e.navID = anchor.navID;
                tag = false;
              }
            });
            if (tag) {
              this.baseList.push(anchor);
            }
            this.save_anchor(this.baseList)
          } else {
            this.$message.error(res.message);
          }
        });
      } else if (this.createNav === false && this.navID) {
        let tag = true;
        anchor.navID = ''
        this.baseList.map(e => {
          if (e.id === anchor.id) {
            e.anchorName = anchor.anchorName;
            e.createNav = this.createNav;
            e.navID = '';
            tag = false;
          }
        });
        if (tag) {
          this.baseList.push(anchor);
        }
        this.deleteNav(parseInt(this.navID), this.save_anchor(this.baseList))
      } else {
        let tag = true;
        this.baseList.map(e => {
          if (e.id === anchor.id) {
            e.anchorName = anchor.anchorName;
            e.createNav = anchor.createNav;
            tag = false;
          }
        });
        if (tag) {
          this.baseList.push(anchor);
        }
        this.save_anchor(this.baseList)
      }
    },
    save_anchor (anchorList, type = 'add') {
      let rowType = this.$store.state.anchor.selectedData.rowType;
      let saveData = {
        page: rowType === 'footer' ? 'common' : this.$store.state.app.now_page,
        anchor: anchorList
      };
      save_anchor(saveData)
        .then(res => {
          if (res.code == 200) {
            if (type === 'add') {
              this.$message.success({
                showClose: true,
                message: i18n.t('components_my_anchor_set_index_2238')
              });
              console.log('锚点设置成功');
            } else {
              this.$message.success({
                showClose: true,
                message: i18n.t('components_my_anchor_set_index_2239')
              });
              console.log('锚点删除成功');
            }

            this.closePop();
          }
        })
        .catch(error => {
          this.$message.error(error);
        }).finally(() => {
          this.$store.state.myRender.common.setting.headerNavRadio = false
          this.$nextTick(() => {
            this.$store.state.myRender.common.setting.headerNavRadio = true
          })
        });
    },
    uuid () {
      let ids = []
      let editData = this.$store.state.anchor.selectedData;
      let anchorName = 'anchor'

      if(typeof this.$store.state.left_sidebar.PendantObj[editData.name]['short_name'] !== undefined){
        anchorName = this.$store.state.left_sidebar.PendantObj[editData.name]['short_name']
      }
      let list = this.baseAllList.thisPage.concat(this.baseAllList.common)

      for (var i = 0; i < list.length; i++) {
        ids.push(list[i]['id'])
      }
      for (var j = 1; j < 999; j++) {
        if(ids.indexOf(anchorName + '_' + j) === -1){
          return anchorName + '_' + j;
          break
        }
      }
      this.$message.error(i18n.t('components_my_anchor_set_index_2240'))
      return false

      // var s = [];
      // var hexDigits = '0123456789abcdef';
      // for (var i = 0; i < 36; i++) {
      //   s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
      // }
      // s[14] = '4'; // bits 12-15 of the time_hi_and_version field to 0010
      // s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
      // s[8] = s[13] = s[18] = s[23] = '-';

      // var uuid = s.join('');
      // return uuid;
    },
    close_dialog () {
      this.dialogVisible = true
      if (!this.confirmDisabled) {
        this.$confirm(i18n.t('view_dialog_index_170'), {
          confirmButtonText: i18n.t('view_public_topbar_24'),
          cancelButtonText: i18n.t('view_public_topbar_11'),
          type: 'warning'
        }).then(() => {
          // 不保存退出
          this.dialogVisible = false
          this.$store.commit('anchor/SET_popShow', false);
        }).catch(() => {
          // 啥也不做
        })
      } else {
        this.dialogVisible = false
        this.$store.commit('anchor/SET_popShow', false);
      }
    }
  },
  mounted () {
    this.get_anchor();
  }
};
</script>

<style lang="scss" scoped>
.anchor_set /deep/ .el-dialog__body {
  height: 206px;
  border-top: 1px solid #e3e2e8;
  padding: 25px 50px 0;
}
.anchorName {
  font-size: 0;
  margin-bottom: 30px;
  .label_words {
    font-size: 14px;
    display: inline-block;
    vertical-align: middle;
  }
  .nameInput {
    display: inline-block;
    vertical-align: middle;
    width: 220px;
  }
  .removeAnchor {
    cursor: pointer;
    font-size: 14px;
    display: inline-block;
    vertical-align: middle;
    margin-left: 7px;
  }
  .removeAnchor:hover {
    color: #5874d8;
  }
}

.anchor_pop {
  /deep/ .el-dialog__footer {
    .dialog-footer {
      text-align: center;
      .el-button {
        margin: 8px 18px;
        padding: 0 28px;
        height: 34px;
      }
    }
  }
}

.anchor_popover {
  margin-left: 6px !important;
  padding: 10px;
  .jz_tooltip_img {
    padding: 10px;
    .jz_tooltip_img_title {
      margin-bottom: 16px;
      color: #666;
      font-size: 13px;
    }
    .jz_tooltip_img_img {
      display: block;
      margin: 0 auto;
      width: 168px;
      height: 118px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/my_anchor_set/index.vue